export enum EVENT_STATUS {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
}

export const EVENT_STATUS_OPTIONS = [
  { name: 'All Statuses', id: 'ALL_STATUSES' },
  { name: 'Draft', id: EVENT_STATUS.DRAFT },
  { name: 'Published', id: EVENT_STATUS.PUBLISHED },
];

export enum EVENT_PHASE {
  REGISTRATION = 'Registration',
  EVENT = 'Event',
}

export const EVENT_PHASE_OPTIONS = [
  { label: 'Registration', value: EVENT_PHASE.REGISTRATION },
  { label: 'Event', value: EVENT_PHASE.EVENT },
];

export enum Icons {
  Luggage = 'Luggage',
  Pint = 'Pint',
  Bread = 'Bread',
  ShoppingBag = 'ShoppingBag',
  UserProfiles = 'UserProfiles',
  Coffee = 'Coffee',
  Car = 'Car',
  Golf = 'Golf',
  ToolsKitchen = 'ToolsKitchen',
  Wine = 'Wine',
  Leaf = 'Leaf',
  PresentationChartBar = 'PresentationChartBar',
  Speakerphone = 'Speakerphone',
  Trophy = 'Trophy',
  Messages = 'Messages',
  Flower = 'Flower',
  Newspaper = 'Newspaper',
  Mail = 'Mail',
  Box = 'Box',
  Calendar = 'Calendar',
  MapPin = 'MapPin',
  Reader = 'Reader',
  Gift = 'Gift',
  Shoe = 'Shoe',
  Footsteps = 'Footsteps',
  ChefHat = 'ChefHat',
}
